import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsMojangstudiosComponent } from './simple-icons-mojangstudios.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsMojangstudiosComponent ],
    exports:      [ SimpleIconsMojangstudiosComponent ],
    bootstrap:    []
})
export class SimpleIconsMojangstudiosModule {}
